// Firebase configuration
// This file can be imported and used directly, or you can use firebase-config.json in public folder

// Option 1: Import this file and export config
// Option 2: Place firebase-config.json in public/ folder (loaded at runtime)

export const firebaseConfig = {
  // These values can come from:
  // 1. Environment variables (REACT_APP_FIREBASE_*)
  // 2. firebase-config.json file in public/ folder (loaded at runtime)
  // 3. Direct values here (not recommended for production)
  
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ""
};

